import React from 'react';
import { ArcStack } from '@src/core/ui';
import { CameraControls, ControllerHeader, ControllerPageLoading, FlightControls, GamepadImage } from './components';
import { useControllerSettings } from './hooks/useControllerSettings';

const ControllerPage: React.FC = () => {
  const {
    controllerMode,
    cameraControls,
    isLoading,
    handleModeChange,
    handleCameraControlChange,
    handleReset,
  } = useControllerSettings();

  if (isLoading) {
    return <ControllerPageLoading />;
  }

  return (
    <ArcStack p={16} pt={6} spacing={6}>
      <ControllerHeader onReset={handleReset} />
      <GamepadImage />
      <ArcStack direction='row' spacing={6}>
        <FlightControls controllerMode={controllerMode} onModeChange={handleModeChange} />
        <CameraControls cameraControls={cameraControls} onCameraControlChange={handleCameraControlChange} />
      </ArcStack>
    </ArcStack>
  );
};

export default ControllerPage;
